import React from "react";
import { useNavigate } from "react-router";
import ResizeListener from "../../../utility/ResizeListener";
import { LedgerHeader } from "../../../utility/TableHeaders";
import BodyComponent from "../../components/BodyComponent";
import CustomTable from "../../components/customTable/CustomTable";
import TopHeaderComponent from "../../components/TopHeaderComponent";
import { WHITE_COLOR } from "../../resources/colorsManager";

const Data = [
  {
    slno: 1,
    createdDate: "01/01/2022 04:35 PM",
    description: "VA_UTRNO",
    debit: "₹00.00",
    credit: "₹10000.00",
    closingBalance: "₹10000.00",
  },
  {
    slno: 2,
    createdDate: "04/04/2022 12:01 PM",
    description: "VA_UTRNO_TAX",
    debit: "₹05.00",
    credit: "₹00.00",
    closingBalance: "₹9995.00",
  },
  {
    slno: 3,
    createdDate: "05/04/2022 11:15 PM",
    description: "VA_UTRNO_CHRG",
    debit: "₹00.90",
    credit: "₹00.00",
    closingBalance: "₹9994.10",
  },
];

function Transactions() {
  const { width, height } = ResizeListener();
  const navigate = useNavigate();
  return (
    <BodyComponent style={{ width: "100%" }}>
      <TopHeaderComponent
        headerName="Recent Transaction"
        isSearchRequired={true}
        inputStyle={{
          width: width * 0.3,
          minWidth: 300,
        }}
        placeholder="Search Transaction ID...."
        onClickBack={() => {
          navigate(-1);
        }}
        showFilter={false}
        showDownload={false}
      />
      <div
        style={{
          marginTop: 20,
        }}
      >
        <CustomTable headers={LedgerHeader} data={Data} totalElements={0} />
      </div>
    </BodyComponent>
  );
}

export default Transactions;
